import InsightCampaign from '../../../../components/AssetManagement/Overview/Insights/InsightAdgroupandCampaign/InsightCampaign'

const InsightCampaignScreen = () => {
  return (
    <div>
        <InsightCampaign />
    </div>
  )
}

export default InsightCampaignScreen